import { render, staticRenderFns } from "./UpdatesEditor.vue?vue&type=template&id=3224d85a&scoped=true&"
import script from "./UpdatesEditor.vue?vue&type=script&lang=ts&"
export * from "./UpdatesEditor.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatesEditor.vue?vue&type=style&index=0&id=3224d85a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3224d85a",
  null
  
)

export default component.exports